export enum DoorMetalMylar {
  Metal = 'Metal',
  Mylar = 'Mylar',
}
